import { render, staticRenderFns } from "./ButtonPrimary.vue?vue&type=template&id=a65e5a32&scoped=true"
import script from "./ButtonPrimary.vue?vue&type=script&lang=js"
export * from "./ButtonPrimary.vue?vue&type=script&lang=js"
import style0 from "./ButtonPrimary.vue?vue&type=style&index=0&id=a65e5a32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65e5a32",
  null
  
)

export default component.exports